import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import HOME_PHONE from "../constants/lib/homePhone";
import { homePhoneService } from "../services/homePhoneService";
import { HomePhoneProduct } from "../types/homePhone";
import { customLogger } from "../utils/Logger";

interface UseHomePhoneProductsResult {
  products: HomePhoneProduct[];
  loading: boolean;
}

const useHomePhoneProducts = (): UseHomePhoneProductsResult => {
  const [products, setProducts] = useState<HomePhoneProduct[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchProducts = useCallback(async () => {
    setLoading(true);
    try {
      const data = await homePhoneService.getProducts();
      setProducts(data);
    } catch (error: unknown) {
      customLogger(error);
      toast.error(
        error instanceof Error
          ? error.message
          : HOME_PHONE.ERRORS.LOAD_PRODUCTS,
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  return { products, loading };
};

export default useHomePhoneProducts;
